import React from 'react';
import './Badge.css';

const Badge = ({
  children,
  variant = 'default',
  className = '',
}) => {
  return (
    <span className={`p-badge p-badge--${variant} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
